// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".AdminLocationDataScan__View[data-v-b712cb7e] {\n  padding: 20px;\n}\nh1[data-v-b712cb7e] {\n  font-size: 25px;\n  padding: 5px 0 20px 0;\n}\n.field[data-v-b712cb7e] {\n  width: 400px;\n}\n[data-v-b712cb7e] .switch {\n  direction: ltr;\n}\n", ""]);
// Exports
module.exports = exports;
